// Angular Files
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

// Angular Material Files
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
    MatProgressSpinnerModule
} from '@angular/material/progress-spinner';

// Teller Online Library Files
import {
    TellerOnlineScheduleDetailsModule
} from 'teller-online-libraries/shared';

// Component Files
import {
    ScheduleDetailsModalComponent
} from './schedule-details-modal.component';
import {
    FullPageDialogHeaderModule
} from '../full-page-dialog-header/full-page-dialog-header.module';
import {
    PaymentMethodDisplayModule
} from '../payment-method-display/payment-method-display.module';

@NgModule({
    declarations: [ScheduleDetailsModalComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatCheckboxModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        TellerOnlineScheduleDetailsModule,
        FullPageDialogHeaderModule,
        PaymentMethodDisplayModule,
    ],
    exports: [ScheduleDetailsModalComponent]
})
export class ScheduleDetailsModalModule {}
